<tyt-dev-tools-menu [menu]="rootMenu"></tyt-dev-tools-menu>

@if (!pinnedMenusLoaded) {
  <button class="root-button" mat-icon-button matTooltip="Loading pinned menus...">
    <app-spinner class="line" [inline]="true" />
  </button>
} @else {
  @if (pinnedMenus.length > 0) {
    @if (expanded) {
      @for (menu of pinnedMenus; track menu.id) {
        <tyt-dev-tools-menu [menu]="menu"></tyt-dev-tools-menu>
      }
      @if (pinnedMenus.length > 1) {
        <button class="root-button collapse" mat-icon-button aria-label="Dev Tools" matTooltip="Expand developer tools" (click)="expanded = false">
          <mat-icon>arrow_left</mat-icon>
        </button>
      }
    } @else {
      <button class="root-button" mat-icon-button aria-label="Dev Tools" matTooltip="Expand developer tools" (click)="expanded = true">
        <mat-icon>arrow_right</mat-icon>
      </button>
    }
  }
}